import { Button } from "@fluentui/react-components";
import React from "react";

import { firebaseSignIn } from "../../../../firebase/helper";

import optiumLogo from "../../../../images/optium_logo.svg";

import { translation } from "@/i18n";
import { nsAuth } from "@/i18n/locales/auth";
import { LanguageSelectLoginDropdown } from "../../../LanguageSelect/LanguageSelectLoginDropdown";
import styles from "./index.module.css";

const useTranslation = translation.use(nsAuth);

export const LoginView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.languageSelect}>
        <LanguageSelectLoginDropdown />
      </div>
      <div className={styles.contentBox}>
        <div className={styles.logo}>
          <img src={optiumLogo} width={240} alt="OPTIUM" />
        </div>
        <Button
          className={styles.loginButton}
          onClick={async () => {
            await firebaseSignIn({ isReplaceHistory: true });
          }}
        >
          {t.auth.login.button()}
        </Button>
      </div>
    </div>
  );
};
